<ac-layer
    #result
    acFor="let point of entities$"
    [context]="this"
    [show]="show"
    [store]="true"
>
    <ac-point-primitive-desc
        props="{
      position: point.position,
      pixelSize : 6,
      color: color(),
      outlineColor: Cesium.Color.WHITE,
      outlineWidth: 0.3,
   }"
    >
    </ac-point-primitive-desc>
</ac-layer>
